import {useMutation, useQueryClient} from '@tanstack/react-query';
import shipmentUpdaters from '@/api/updaters/shipments';

function useAssumeDelivery() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['shipments', 'assumeDelivery'],
    mutationFn: shipmentUpdaters.assumeDelivery,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: ['campaignV2Creators']});
      queryClient.invalidateQueries({queryKey: ['campaignV2CreatorsCounts']});
    },
  });
}

export default useAssumeDelivery;
